// !!!!!!!DEPRECATED!!!!!!!
// use useClerk hook instead

import { ClerkClient } from '@utils/clerk/client';

export const clerk = new ClerkClient();
